import { BaseDto } from "@models/base/baseDto.model";
import { CasoDto } from "@models/caso/casoDto.model";
import { EmpresaDto } from "@models/empresa/empresaDto.model";
import { JuzgadoDto } from "@models/juzgado/juzgadoDto.model";
import { PersonaDto } from "@models/persona/personaDto.model";
import { TipoMonedaDto } from "@models/tipoMoneda/tipoMoneda.model";
import { UsuarioSummaryDto } from "@models/usuario/usuarioSummaryDto.model";

export class ExpedienteDto {
  public id!: number;
  public descripcion!: string;
  public observaciones!: string;
  public fechaAlta!: Date;
  public idUsuario!: number;
  public creadoPor!: number;
  public modificadoPor!: number;
  public ubicacion!: string;
  public caratula!: string;
  public identificadorUnico!: string;
  public numero!: string;
  public demanda!: string;
  public demandado!: string;
  public causa!: string;
  public numeroCarpeta!: string;
  public numeroArchivo!: string;
  public responsable!: string;
  public separadorCaratula!: string;
  public activo!: boolean;
  public estadoExpediente!: BaseDto;
  public juzgado!: JuzgadoDto;
  public tipoExpediente!: BaseDto;
  public claveExpediente!: string;
  public sufijo!: string;
  public bis!: string;
  public fechaIngresoMEU!: Date;
  public fechaModificacion!: Date;
  public fechaBaja!: Date;
  public montoDemanda!: number;
  public persona!: PersonaDto;
  public empresa!: EmpresaDto;
  public caso!: CasoDto;
  public estadoProcesal!: BaseDto;
  public fechaInicio!: Date;
  public fechaFin!: Date;
  public tipoGrupoExpediente!: BaseDto;
  public tipoPrioridad!: BaseDto;
  public asignadoA!: UsuarioSummaryDto;
  public expanded?: boolean; // Para manejar la expansión del detalle
  public etiquetas!: string;
  public tokenAcceso!: string;
  public urlGestion!: string;
  public tipoMonedaDto!: TipoMonedaDto;
}
